import React, { useState } from 'react';
import {
  ListItem,
  TextField,
  InputAdornment,
  IconButton
} from '@material-ui/core';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import SearchIcon from '@material-ui/icons/Search';
import NavItem from './NavItem';

class ListCats extends React.Component {
  constructor(props) {
    super(props);
    this.onChecked = this.onChecked.bind(this);
  }

  // eslint-disable-next-line class-methods-use-this
  onChecked(e) {
    const index = e.target.getAttribute('data-index');
    const value = e.target.value;
    const status = this.props.cats[index].status;
    this.props.cats[index].status = !status;
    this.props.setCats(this.props.cats);
  }

  render() {
    let template;
    if (this.props.cats == null) {
      template = 'No cats';
    } else {
      template = this.props.cats.map((item, index) => (
        <NavItem
          href={item.href}
          title={item.title}
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          colorKey={index}
          status={item.status}
          termId={item.term_id}
          slug={item.slug}
          onChecked={this.onChecked}
        />
      ));
    }
    return (
      <>
        <ListItem
          style={{
            display: 'flex',
            paddingTop: 15,
            paddingBottom: 15,
            marginBottom: 15
          }}
          disableGutters
        >
          <TextField
            style={{ width: '100%' }}
            id="outlined-basic"
            label="Search"
            variant="outlined"
            onChange={this.props.setKeyword}
            onKeyDown={this.props.pressEndter}
            InputProps={{
              endAdornment:
  <InputAdornment position="end">
    <IconButton
      aria-label="toggle password visibility"
      onClick={this.props.searchKeyword}
    >
      <SearchIcon />
    </IconButton>
  </InputAdornment>,
            }}
          />
        </ListItem>
        {template}
      </>
    );
  }
}

NavItem.propTypes = {
  className: PropTypes.string
};

export default ListCats;
